<template>
<div class="suggestion-header">
    <UserProfile :user="originalPoster" :date="suggestion.createdAt"/>
    <transition name="fade" appear>
        <div v-if="suggestion.isNotification" class="notification-dot" />
    </transition>
    <EmotePickerTrigger
        :suggestion="suggestion"
        :isAllowedToEmote="isAllowedToEmote"
        data-tippy-content="Add Reaction"
        ref="emoteTrigger"
        key="emoteTrigger" />
    <span v-show="showActions" ref="menuTippyRef" class="icon menu-icon">
        <FaIcon icon="ellipsis-v" size="sm"/>
    </span>
    <div v-show="false"><!-- Hide tippy initially -->
        <SuggestionActions
            :suggestion="suggestion"
            :isAdmin="isAdmin"
            :isOriginalPoster="isOriginalPoster"
            ref="menuTippyContent" />
    </div>
</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import tippy from '@/tippy'
import UserProfile from '@/components/UserProfile'
import EmotePickerTrigger from '@/components/emotes/EmotePickerTrigger'
import SuggestionActions from '@/components/viewer/SuggestionActions'

export default {
    name: 'SuggestionHeader',
    props: {
        suggestion: Object,
        isAllowedToEmote: Boolean,
    },
    data: () => ({
        hasImgErr: false,
    }),
    computed: {
        ...mapGetters(['isAdmin', 'userId']),
        originalPoster: vm => vm.suggestion.user,
        isOriginalPoster: vm => vm.originalPoster.id === vm.userId,
        showActions: vm => vm.isAdmin || vm.isOriginalPoster,
    },
    mounted () {
        const opts = { placement: 'bottom' }
        const $refs = this.$refs
        const textTippy = tippy($refs.emoteTrigger.$el, opts)
        const menuTippy = tippy($refs.menuTippyRef, {
            ...opts,
            content: ref => $refs.menuTippyContent.$el,
            interactive: true,
            interactiveBorder: 5,
            appendTo: this.$el,
            hideOnClick: false,
            //trigger: 'click', // DEBUG ONLY
        })

        this.$once('hook:destroyed', () => {
            [textTippy, menuTippy].forEach(t => t.destroy())
        })
    },
    components: {
        UserProfile,
        SuggestionActions,
        EmotePickerTrigger,
    }
}
</script>

<style lang="scss">

@mixin active-icon {
    filter: grayscale(0);
    opacity: 1;
}

.suggestion {
    &:hover {
        .menu-icon, .emote-popper-reference {
            @include active-icon;
        }
    }
    .menu-icon, .emote-popper-reference {
        filter: grayscale(90%);
        opacity: 0.5;
        transition: 0.15s;
        &.is-active {
            @include active-icon;
        }
    }
}
</style>

<style lang="scss" scoped>
$info-size: 20px;

.suggestion-header {
    display: flex;
    align-items: center;
    max-height: $info-size;
    overflow: hidden; // necessary to enable text-overflow ellipsis
}

.notification-dot {
    width: 5px;
    height: 5px;
    margin-right: 0.4rem;
    border-radius: 50%;
    background: $notification-color;
}

.user-profile {
    margin-right: auto;
}

.icon {
    cursor: pointer;
}
</style>
